import type { FaqItem, SeoLandingConfig } from "./types";

export const SITE_URL = "https://fidexa.com.br";

export const buildBreadcrumbSchema = (config: SeoLandingConfig) => {
  const trail = [
    { name: "Início", path: "/" },
    ...(config.breadcrumbParent ? [config.breadcrumbParent] : []),
    { name: config.breadcrumbLabel, path: config.path },
  ];

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: trail.map((step, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: step.name,
      item: `${SITE_URL}${step.path}`,
    })),
  };
};

export const buildServiceSchema = (config: SeoLandingConfig) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: config.service.name,
  serviceType: config.service.serviceType,
  provider: { "@type": "Organization", name: "Fidexa", url: SITE_URL },
  areaServed: { "@type": "Country", name: "Brasil" },
  audience: { "@type": "BusinessAudience", name: config.service.audience },
  description: config.description,
  inLanguage: "pt-BR",
  url: `${SITE_URL}${config.path}`,
});

export const buildFaqSchema = (items: FaqItem[], updatedAt: string) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  dateModified: updatedAt,
  mainEntity: items.map(item => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: { "@type": "Answer", text: item.answer },
  })),
});
